import React, { useState, useEffect, useRef } from "react";
import { Chart } from "react-google-charts";

interface BubbleChartProps {
  data: any[];
  options: any;
  isLoading?: boolean;
}

export const BubbleChart = ({ data, options, isLoading }: BubbleChartProps) => {
  const [chartSize, setChartSize] = useState({ width: 0, height: 0 });
  const [chartKey, setChartKey] = useState(0);
  const chartContainerRef = useRef<HTMLDivElement>(null); // Reference to the chart container

  useEffect(() => {
    const chartContainer = chartContainerRef.current;

    const resizeObserver = new ResizeObserver(() => {
      if (chartContainer) {
        setChartSize({
          width: chartContainer.offsetWidth,
          height: chartContainer.offsetHeight,
        });
        setChartKey((prevKey) => prevKey + 1); // Force re-render by updating key
      }
    });

    if (chartContainer) {
      resizeObserver.observe(chartContainer);
    }

    // Clean up observer when the component unmounts
    return () => {
      if (chartContainer) {
        resizeObserver.unobserve(chartContainer);
      }
    };
  }, []);

  return (
    <div ref={chartContainerRef} className="m-chart">
      {isLoading ? (
        <div className="m-chart__skelton"></div>
      ) : data.length ? (
        <Chart
          key={chartKey}
          chartType="BubbleChart"
          width={chartSize.width}
          height={chartSize.height}
          data={data}
          options={options}
        />
      ) : (
        <p className="m-chart__nodata">No Data Found</p>
      )}
    </div>
  );
};
